@if (!isQuoteTemplate && !isLeadPanel) {
  <div id="breadcrumbContainer" class="breadcrumb-container">
    <ds-breadcrumbs id="breadcrumbs" [breadcrumbs]="breadcrumbs" separatorType="slash" [collapsable]="false"></ds-breadcrumbs>
  </div>
}

@if (!isQuoteTemplate && !isLeadPanel && !isMobile) {
  <div class="header-container">
    <div class="header-title">
      <div class="title-container">
        <typography id="contactTitle" variant="mat-headline-4" weight="bold">{{ title }}</typography>
        @if (accountName) {
          <typography id="contactSeparator" variant="mat-headline-4" weight="bold">|</typography>
          <typography id="contactAccountName" variant="mat-headline-4" weight="bold">{{ accountName }}</typography>
        }
      </div>
      @if (bpNumber) {
        <ds-chip id="bpNumber" variant="filled" size="medium">{{appStrings.quote_bpLabel}}: {{ bpNumber }}</ds-chip>
      }
    </div>
    <div class="header-buttons">
      @if (isOnline && isEditMode && canEdit) {
        <ds-button id="deleteButton"
          size="large" type="secondary" variant="label-only" [label]="appStrings.contacts_deleteContactTitle"
          (onClick)="deleteContact()">
        </ds-button>
      }
      <ds-button id="cancelButton" size="large" type="secondary"
        variant="label-only" [label]="appStrings.button_cancel" (onClick)="confirmCancel()">
      </ds-button>
      @if (isEditMode) {
        <div>
          <ds-button id="saveButtonEdit" size="large" type="primary"
            variant="label-only" [isDisabled]="!isOnline || isLoading" [label]="appStrings.button_save"
            (onClick)="editSaveChanges()">
          </ds-button>
        </div>
      } @else {
        @if (!shouldNotDisplayPhoto) {
          <ds-button id="saveNewButton" size="large"
            type="secondary" variant="label-only" [isDisabled]="isLoading"
            [label]="appStrings.button_saveAndNew" (onClick)="saveChangesAndNew()">
          </ds-button>
        }
        <ds-button id="saveButton" size="large" type="primary"
          variant="label-only" [isDisabled]="isLoading" [label]="appStrings.button_save"
          (onClick)="saveChanges()">
        </ds-button>
      }
    </div>
  </div>
}

@if (isQuoteTemplate) {
  <div id="quoteTemplateContainer">
    <div mat-dialog-title class="ds">
      <span id="dialogTitle">{{appStrings.paymentDetails_create_contact}}</span>
      <button mat-icon-button class="close-dialog-button" mat-dialog-close>
        <mat-icon id="closeButton" class="close-icon">close</mat-icon>
      </button>
    </div>
    @if (isLoading) {
      <div class="loading center">
        <ds-progress-spinner id="loading" progress_mode="indeterminate"></ds-progress-spinner>
      </div>
    }
    @if (!isLoading) {
      <div id="dialogContentDiv" mat-dialog-content class="content ds">
        <div class="section">
          <div id="nameTitle" class="title">
            <typography id="nameTitleText" variant="mat-body-2" weight="bold"> {{ appStrings.contacts_name }} </typography>
          </div>
          <ds-textfield id="firstNameInput" class="fill-width fill-gap quarter-width" [label]="appStrings.contacts_firstName" label_orientation="vertical-label"
            [control]="form.controls.firstName" [maxLength]="maxLengthsInputs.firstName">
          </ds-textfield>
          <ds-textfield id="middleNameInput" class="fill-width fill-gap quarter-width" [label]="appStrings.contacts_middleName" label_orientation="vertical-label"
            [control]="form.controls.middleName" [maxLength]="maxLengthsInputs.middleName">
          </ds-textfield>
          <ds-textfield id="lastNameInput" class="fill-width fill-gap quarter-width" [label]="appStrings.contacts_lastName" label_orientation="vertical-label"
            [control]="form.controls.lastName" [maxLength]="maxLengthsInputs.lastName">
          </ds-textfield>
          <ds-textfield id="suffixInput" class="fill-width fill-gap quarter-width" [label]="appStrings.contacts_suffix" label_orientation="vertical-label"
            [control]="form.controls.suffix" [maxLength]="maxLengthsInputs.suffix">
          </ds-textfield>
          <ds-textfield id="departmentInput" class="fill-width fill-gap half-width" [label]="appStrings.contacts_department" label_orientation="vertical-label"
            [control]="form.controls.department" [maxLength]="maxLengthsInputs.department">
          </ds-textfield>
          <ds-textfield id="titleInput"  class="fill-width fill-gap half-width" [label]="appStrings.contacts_title" label_orientation="vertical-label"
            [control]="form.controls.title" [maxLength]="maxLengthsInputs.title">
          </ds-textfield>
        </div>
        <ds-divider></ds-divider>
        <div class="section column" id="containerEmailPhoneNo">
          <div id="contactTitleDiv" class="title">
            <typography id="contactTitle" variant="mat-body-2" weight="bold"> {{ appStrings.label_contact }} </typography>
          </div>
          <ds-textfield id="emailInput" class="fill-width fill-gap half-width" [label]="appStrings.contacts_email" label_orientation="vertical-label"
            [control]="form.controls.email">
          </ds-textfield>
          <div id="phoneContainer" class="phone-container">
            @for (item of phonesControls; track item; let i = $index) {
              <div [id]="'phoneContainer-' + i" class="phone-item">
                @if (!item.value.isDeleted) {
                  <div id="phoneSection" class="section">
                    <ds-select id="phoneTypeSelect" (selectionChange)="togglePhoneType(item)" [label]="appStrings.contacts_phoneType"
                      [dropOptions]="displayPhoneTypes" label_orientation="vertical-label" class="no-subscript"
                      [control]="item.controls.phoneType">
                    </ds-select>
                    <ds-textfield id="phoneNumberInput" class="fill-width half-width no-subscript" [label]="appStrings.contacts_number" label_orientation="vertical-label"
                      [control]="item.controls.phoneNumber" (onBlur)="togglePhoneType(item)" [maxLength]="maxLengthsInputs.phoneNumber">
                    </ds-textfield>
                    <ds-button id="deleteBtn" class="delete-button" variant="icon-only" type="secondary" size="medium" (onClick)="deletePhoneNumber(i)"
                      icon="delete" iconStyle="material-icons-outlined">
                    </ds-button>
                  </div>
                }
              </div>
            }
          </div>
          <div class="add-button">
            <ds-button id="addBtn" variant="label-only" label_orientation="vertical-label" [label]="appStrings.contacts_addNumber"
              type="secondary" size="medium" (click)="addPhoneNumber()">
            </ds-button>
          </div>
        </div>
        <ds-divider></ds-divider>
        <div class="section" id="containerAddressDetails">
          <div id="addressTitleDiv" class="title">
            <typography id="addressTitle" variant="mat-body-2" weight="bold"> {{ appStrings.contacts_address }} </typography>
          </div>
          <ds-textfield id="primaryAddressInput" class="fill-width fill-gap half-width" [label]="appStrings.contacts_addressLine1" label_orientation="vertical-label"
            [control]="addressFormControls.addressline1" [maxLength]="maxLengthsInputs.addressLine1">
          </ds-textfield>
          <ds-textfield id="secondaryAddressInput" class="fill-width fill-gap half-width" [label]="appStrings.contacts_addressLine2" label_orientation="vertical-label"
            [control]="addressFormControls.addressline2" [maxLength]="maxLengthsInputs.addressLine2">
          </ds-textfield>
          <ds-textfield id="cityInput" class="fill-width fill-gap quarter-width" [label]="appStrings.contacts_city" label_orientation="vertical-label"
            [control]="addressFormControls.city" [maxLength]="maxLengthsInputs.city">
          </ds-textfield>
          @if (!countryWithCounty && !countryWithHiddenStateProvince) {
            @if (stateList[form.value.address.countryId]) {
              <ds-select id="stateSelect" class="fill-width fill-gap quarter-width" [label]="appStrings.contacts_state_province" [dropOptions]="displayStateList[form.value.address.countryId]"
                label_orientation="vertical-label" [control]="addressFormControls.stateId">
              </ds-select>
            } @else {
              <ds-textfield id="stateInput" class="fill-width fill-gap quarter-width" [label]="appStrings.contacts_state_province" label_orientation="vertical-label"
                [control]="addressFormControls.province.controls.name">
              </ds-textfield>
            }
          }
          <ds-textfield id="zipInput" class="fill-width fill-gap quarter-width" [label]="appStrings.contacts_zip" label_orientation="vertical-label"
            [control]="addressFormControls.zip" [maxLength]="maxLengthsInputs.zipCode">
          </ds-textfield>
          <ds-select id="countryInput" class="fill-width fill-gap quarter-width" [label]="appStrings.contacts_country" [dropOptions]="displayCountryList"
            label_orientation="vertical-label" [control]="addressFormControls.countryId" (selectionChange)="countryChangedEvent($event.source.value)">
          </ds-select>
          @if (countryWithCounty) {
            <ds-select id="regionSelect" class="fill-width fill-gap quarter-width" [label]="appStrings.contacts_region" [dropOptions]="displayRegionList"
              label_orientation="vertical-label" [control]="addressFormControls.regionId" (selectionChange)="regionChangedEvent($event.source.value)">
            </ds-select>
            @if (form.value.address.regionId) {
              <ds-select id="countySelect" class="fill-width fill-gap quarter-width" [label]="appStrings.contacts_county"
                label_orientation="vertical-label" [dropOptions]="displayCountyList" [control]="addressFormControls.countyId">
              </ds-select>
            }
          }
        </div>
        <ds-divider></ds-divider>
        <div class="section" id="containerNotes">
          <div id="notesTitleDiv" class="title">
            <typography id="notesTitle" variant="mat-body-2" weight="bold"> {{ appStrings.contacts_notes }} </typography>
          </div>
          <ds-multiline id="notesMultiline" class="fill-width" [label]="appStrings.contacts_note" label_orientation="vertical-label"
            [control]="form.controls.notes" [maxLength]="maxLengthsInputs.note">
          </ds-multiline>
          <div id="addNoteButtonDiv" class="add-note-button">
            <ds-button id="addNoteBtn" variant="label-icon" size="medium" type="secondary" [label]="appStrings.notesWidget_addNote"
              iconStyle="material-icons-outlined" icon="add" (click)="addNote()" [isDisabled]="!form.controls.notes.value">
            </ds-button>
          </div>
          @for (note of notesTableData; track note; let i = $index) {
            <div id="note" class="note" [id]="'note'+i">
              <ds-paper id="notePaperTemplate" outline="outlined" insidePaddingTop="top-spacing_XL" insidePaddingBottom="bottom-spacing_XL"
                insidePaddingLeft="left-spacing_L" insidePaddingRight="right-spacing_L">
                <div id="noteContainer" class="note-container">
                  <div id="note-content" class="note-content">
                    <typography id="noteDate" variant="mat-caption-1" weight="bold" class="row">{{ note.date | date:dateTimeFormat }}</typography>
                    <typography id="noteDetail" variant="mat-body-2" weight="regular" class="row">{{ note.detail }}</typography>
                  </div>
                  <div id="note-actions">
                    <ds-button id="deleteNoteBtn" class="delete-note-button" size="medium" type="tertiary" variant="icon-only" icon="delete"
                      (onClick)="deleteNote(i)" iconStyle="material-icons-outlined">
                    </ds-button>
                  </div>
                </div>
              </ds-paper>
            </div>
          }
        </div>
      </div>
    }
    <div mat-dialog-actions align="end" class="ds">
      <div class="dialog-btn-wrapper">
        <ds-button id="closeBtn" variant="label-only" size="medium" type="secondary" [label]="appStrings.button_close" (onClick)="confirmCancel()"></ds-button>
        <ds-button id="addBtn" variant="label-only" size="medium" type="primary" [label]="appStrings.button_add" (onClick)="saveChanges()"></ds-button>
      </div>
    </div>
  </div>
}

@if (!isQuoteTemplate) {
  <form #contactFormTop id="main-form" [formGroup]="form" [ngClass]="{'standalone-page': !isLeadPanel}">
    <!-- Desktop view -->
    <mat-accordion *appIsDesktop id="contactDetailsContainer" [ngClass]="{'hide-accordion': !isLeadPanel}">
      <mat-expansion-panel id="contactDetailsSummary" hideToggle [expanded]="!isLeadPanel"
        [ngClass]="{'mat-expansion-panel-collapsed': !isLeadPanel}" (opened)="setOpened()" (closed)="setClosed()">
        <mat-expansion-panel-header id="quoteDetailsSummary" [ngClass]="{'mat-expansion-table-collapsed': !isLeadPanel}">
          @if (isLeadPanel) {
            <div id="contactsHeaderDetails" class="contacts-header-details">
              @if (form.controls.firstName.value.length > 0 && !contactsOpened) {
                <div class="contacts-header-name">
                  <typography variant="mat-body-1" weight="medium" class="name">{{ form.controls.firstName.value }} {{ form.controls.lastName.value }}</typography>
                  <typography variant="mat-body-2" weight="regular" class="title">{{ form.controls.title.value }}</typography>
                </div>
              }
              <typography id="ContactDetailesHeaderSection" variant="mat-subtitle-1" weight="medium" class="section-header">{{ appStrings.contacts_contactDetails }}</typography>
              @if (isLeadPanel) {
                <ds-checkbox id="sameAsLeadCheckbox" class="same-as-checkbox" [label]="appStrings.contacts_contactAddressSameAsLead"
                  [control]="form.controls.addressToggleCheckbox" (change)="addressToggle()" (click)="$event.stopPropagation()">
                </ds-checkbox>
              }
            </div>
          }
        </mat-expansion-panel-header>
        <ds-divider></ds-divider>
        <div id="mainContainer" class="main-container">
          <div id="upperContainer" class="upper-container">
            <div id="leftContainer" [ngClass]="{'paper-card': !isLeadPanel}">
              @if (!isQuoteTemplate && !isLeadPanel) {
                <typography variant="mat-heading-6" weight="medium" class="section-title">{{ appStrings.accounts_labelName }}</typography>
              }
              @if (!isQuoteTemplate && !isLeadPanel) {
                <div class="divider">
                  <ds-divider></ds-divider>
                </div>
              }
              <div id="personalInfoContainer" class="column-container personal-info">
                @if (!isLeadPanel && !shouldNotDisplayPhoto) {
                  <div id="imageContainer" class="image-container">
                    <div id="image">
                      <img id="contactPhoto" class="image" alt="contact" [src]="photoUrl" />
                      <div id="imgButtons" class="img-buttons">
                        <ds-button id="new-photo" class="image-buttons" type="secondary" variant="label-icon" size="medium"
                          [label]="appStrings.label_edit" (onClick)="triggerPreviewPhoto()" iconStyle="material-icons-outlined" icon="edit">
                        </ds-button>
                        <input #photoFileInput id="photoFileInput" type="file" (change)="previewPhoto($event)"
                          class="file-input" accept="image/png,image/jpg,image/jpeg" />
                        <ds-button id="deletePhoto" class="image-buttons delete-photo" type="secondary" variant="label-icon" size="medium"
                          [isDisabled]="photoUrl === defaultPhotoUrl"
                          [label]="appStrings.button_delete" (onClick)="deletePhoto()" iconStyle="material-icons-outlined" icon="delete">
                        </ds-button>
                      </div>
                    </div>
                  </div>
                }
                <div id="nameContainer" class="name-container">
                  <ds-textfield id="firstNameInput" class="fill-width half-width no-subscript" [label]="appStrings.contacts_firstName"
                    label_orientation="vertical-label" [control]="form.controls.firstName" [maxLength]="maxLengthsInputs.firstName">
                  </ds-textfield>
                  <ds-textfield id="middleNameInput" class="fill-width half-width no-subscript" [label]="appStrings.contacts_middleName"
                    label_orientation="vertical-label" [control]="form.controls.middleName" [maxLength]="maxLengthsInputs.middleName">
                  </ds-textfield>
                  <ds-textfield id="lastNameInput" class="fill-width half-width no-subscript" [label]="appStrings.contacts_lastName"
                    label_orientation="vertical-label" [control]="form.controls.lastName" [maxLength]="maxLengthsInputs.lastName">
                  </ds-textfield>
                  <ds-textfield id="suffixInput" class="fill-width half-width no-subscript" [label]="appStrings.contacts_suffix"
                    label_orientation="vertical-label" [control]="form.controls.suffix" [maxLength]="maxLengthsInputs.suffix">
                  </ds-textfield>
                  <ds-textfield id="departmentInput" class="fill-width half-width no-subscript" [label]="appStrings.contacts_department"
                    label_orientation="vertical-label" [control]="form.controls.department" [maxLength]="maxLengthsInputs.department">
                  </ds-textfield>
                  <ds-textfield id="titleInput" class="fill-width half-width no-subscript" [label]="appStrings.contacts_title"
                    label_orientation="vertical-label" [control]="form.controls.title" [maxLength]="maxLengthsInputs.title">
                  </ds-textfield>
                </div>
              </div>
            </div>
            <div id="rightContainer" [ngClass]="{'paper-card': !isLeadPanel}">
              @if (!isQuoteTemplate && !isLeadPanel) {
                <typography variant="mat-heading-6" weight="medium" class="section-title">{{ appStrings.label_contact }}</typography>
              }
              @if (!isQuoteTemplate && !isLeadPanel) {
                <div class="divider">
                  <ds-divider></ds-divider>
                </div>
              }
              <div class="column-container">
                <div class="contact-container">
                  <ds-textfield id="emailInput" class="fill-width fill-gap half-width no-subscript" [label]="appStrings.contacts_email" label_orientation="vertical-label"
                    [control]="form.controls.email">
                  </ds-textfield>
                  <div id="phoneContainer" class="phone-container">
                    @for (item of phonesControls; track item; let i = $index) {
                      <div [id]="'phoneContainer-' + i" class="phone-item">
                        @if (!item.value.isDeleted) {
                          <div id="phoneInputs" class="phone-inputs">
                            <ds-select id="phoneTypeSelect" (selectionChange)="togglePhoneType(item)" [label]="appStrings.contacts_phoneType"
                              [dropOptions]="displayPhoneTypes" label_orientation="vertical-label" class="no-subscript"
                              [control]="item.controls.phoneType">
                            </ds-select>
                            <ds-textfield id="phoneNumberInput" class="fill-width fill-gap no-subscript" [label]="appStrings.contacts_number"
                              label_orientation="vertical-label" [control]="item.controls.phoneNumber" (onBlur)="togglePhoneType(item)" [maxLength]="maxLengthsInputs.phoneNumber">
                            </ds-textfield>
                            <div id="phoneButtonsContainer" class="phone-buttons-container">
                              <ds-button id="deleteBtn" class="delete-button" variant="icon-only" type="tertiary" size="medium" (onClick)="deletePhoneNumber(i)"
                                icon="delete" iconStyle="material-icons-outlined">
                              </ds-button>
                              <ds-button [ngClass]="{'hide': i !== 0}" id="addBtn" class="add-small-button" variant="icon-only" type="tertiary" size="medium"
                                (click)="addPhoneNumber()" icon="add" iconStyle="material-icons-outlined">
                              </ds-button>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="secondContainer" [ngClass]="{'paper-card': !isLeadPanel}">
            @if (!isQuoteTemplate && !isLeadPanel) {
              <typography variant="mat-heading-6" weight="medium" class="section-title">{{ appStrings.accounts_labelAddress }}</typography>
            }
            @if (!isQuoteTemplate && !isLeadPanel) {
              <div class="divider">
                <ds-divider></ds-divider>
              </div>
            }
            <div class="address-container">
              <ds-textfield id="primaryAddressInput" class="fill-width fill-gap half-width no-subscript" [label]="appStrings.contacts_addressLine1" label_orientation="vertical-label"
                [control]="addressFormControls.addressline1" [maxLength]="maxLengthsInputs.addressLine1">
              </ds-textfield>
              <ds-textfield id="secondaryAddressInput" class="fill-width fill-gap half-width no-subscript" [label]="appStrings.contacts_addressLine2" label_orientation="vertical-label"
                [control]="addressFormControls.addressline2" [maxLength]="maxLengthsInputs.addressLine2">
              </ds-textfield>
              <ds-textfield id="cityInput" class="fill-width fill-gap quarter-width no-subscript" [label]="appStrings.contacts_city" label_orientation="vertical-label"
                [control]="addressFormControls.city" [maxLength]="maxLengthsInputs.city">
              </ds-textfield>
              @if (!countryWithCounty && !countryWithHiddenStateProvince) {
                @if (stateList[form.value.address.countryId]) {
                  <ds-select id="stateSelect" class="fill-width fill-gap quarter-width no-subscript" [label]="appStrings.contacts_state_province" [dropOptions]="displayStateList[form.value.address.countryId]"
                    label_orientation="vertical-label" [control]="addressFormControls.stateId">
                  </ds-select>
                } @else {
                  <ds-textfield id="stateInput" class="fill-width fill-gap quarter-width" [label]="appStrings.contacts_state_province" label_orientation="vertical-label"
                    [control]="addressFormControls.province.controls.name">
                  </ds-textfield>
                }
                <ng-template #freeInputStateTemplate>
                  <ds-textfield id="stateInput" class="fill-width fill-gap quarter-width no-subscript" [label]="appStrings.contacts_state_province" label_orientation="vertical-label"
                    [control]="addressFormControls.province.controls.name">
                  </ds-textfield>
                </ng-template>
              }
              <ds-textfield id="zipInput" class="fill-width fill-gap quarter-width no-subscript" [label]="appStrings.contacts_zip" label_orientation="vertical-label"
                [control]="addressFormControls.zip" [maxLength]="maxLengthsInputs.zipCode">
              </ds-textfield>
              <ds-select id="countryInput" class="fill-width fill-gap quarter-width no-subscript" [label]="appStrings.contacts_country" [dropOptions]="displayCountryList"
                label_orientation="vertical-label" [control]="addressFormControls.countryId" (selectionChange)="countryChangedEvent($event.source.value)">
              </ds-select>
              @if (countryWithCounty) {
                <ds-select id="regionSelect" class="fill-width quarter-width no-subscript" [label]="appStrings.contacts_region" [dropOptions]="displayRegionList"
                  label_orientation="vertical-label" [control]="addressFormControls.regionId" (selectionChange)="regionChangedEvent($event.source.value)">
                </ds-select>
                @if (form.value.address.regionId) {
                  <ds-select id="countySelect" class="fill-width quarter-width no-subscript" [label]="appStrings.contacts_county"
                    label_orientation="vertical-label" [dropOptions]="displayCountyList" [control]="addressFormControls.countyId">
                  </ds-select>
                }
              }
            </div>
          </div>
          @if (!isLeadPanel) {
            <div id="notes" [ngClass]="{'paper-card': !isLeadPanel}">
              <typography variant="mat-heading-6" weight="medium" class="section-title">{{ appStrings.contacts_notes }}</typography>
              <div class="divider">
                <ds-divider></ds-divider>
              </div>
              <div id="notesArea" class="notes-area">
                <ds-multiline id="notesInput" class="paragraph-text full-width fill-width no-subscript"
                  label_orientation="vertical-label" [control]="form.controls.notes" [maxLength]="maxLengthsInputs.note">
                </ds-multiline>
                <ds-button id="add-note" type="secondary" variant="label-only" size="medium"
                  [label]="appStrings.notesWidget_addNote" [isDisabled]="!form.controls.notes.value"
                  (onClick)="addNote()">
                </ds-button>
              </div>
              @if (notesTableData.length > 0) {
                <div class="divider">
                  <ds-divider></ds-divider>
                </div>
              }
              @for (note of notesTableData; track note; let index = $index) {
                <div id="noteDiv" class="note" [id]="'note'+index">
                  <ds-paper id="notePaper" elevation="elevation_none"
                    borderRadius="radius_S" outline="outlined"
                    insidePaddingTop="top-spacing_XL" insidePaddingBottom="bottom-spacing_XL"
                    insidePaddingLeft="left-spacing_L" insidePaddingRight="right-spacing_L">
                    <div id="noteContentDiv" class="note-content">
                      <typography id="authorDate" variant="mat-caption-1" weight="bold" class="row">{{ note.date | date:dateTimeFormat }}</typography>
                      <typography id="noteText" variant="mat-body-2" weight="regular" class="row">{{note.detail}}</typography>
                    </div>
                    <div id="noteActionsDiv">
                      @if (!isView) {
                        <ds-button id="deleteNoteButton" size="medium" type="tertiary" variant="icon-only" icon="delete"
                          (onClick)="deleteNote(index)" iconStyle="material-icons-outlined">
                        </ds-button>
                      }
                    </div>
                  </ds-paper>
                </div>
              }
            </div>
          }
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <!-- Mobile view -->
    <div *appIsMobile class="mobile">
      @if (isLeadPanel) {
        <mat-expansion-panel class="mobile-panel">
          <mat-expansion-panel-header class="mobile-panel-header">
            <typography variant="mat-subtitle-1" weight="medium">{{ appStrings.contacts_contactDetails }}</typography>
          </mat-expansion-panel-header>
          <div class="section-divider">
            <ds-divider></ds-divider>
          </div>
          <typography variant="mat-body-2" weight="bold" class="section-label">{{ appStrings.accounts_labelName }}</typography>
          <ds-textfield id="firstNameInputMobile" class="fill-width no-subscript" [label]="appStrings.contacts_firstName"
            label_orientation="vertical-label" [control]="form.controls.firstName" [maxLength]="maxLengthsInputs.firstName">
          </ds-textfield>
          <ds-textfield id="middleNameInputMobile" class="fill-width no-subscript" [label]="appStrings.contacts_middleName"
            label_orientation="vertical-label" [control]="form.controls.middleName" [maxLength]="maxLengthsInputs.middleName">
          </ds-textfield>
          <ds-textfield id="lastNameInputMobile" class="fill-width no-subscript" [label]="appStrings.contacts_lastName"
            label_orientation="vertical-label" [control]="form.controls.lastName" [maxLength]="maxLengthsInputs.lastName">
          </ds-textfield>
          <ds-textfield id="suffixInputMobile" class="fill-width no-subscript" [label]="appStrings.contacts_suffix"
            label_orientation="vertical-label" [control]="form.controls.suffix" [maxLength]="maxLengthsInputs.suffix">
          </ds-textfield>
          <ds-textfield id="departmentInputMobile" class="fill-width no-subscript" [label]="appStrings.contacts_department"
            label_orientation="vertical-label" [control]="form.controls.department" [maxLength]="maxLengthsInputs.department">
          </ds-textfield>
          <ds-textfield id="titleInputMobile" class="fill-width no-subscript" [label]="appStrings.contacts_title"
            label_orientation="vertical-label" [control]="form.controls.title" [maxLength]="maxLengthsInputs.title">
          </ds-textfield>
          <div class="section-divider">
            <ds-divider></ds-divider>
          </div>
          <typography variant="mat-body-2" weight="bold" class="section-label">{{ appStrings.label_contact }}</typography>
          <ds-textfield id="emailInputMobile" class="fill-width no-subscript" [label]="appStrings.contacts_email"
            label_orientation="vertical-label" [control]="form.controls.email">
          </ds-textfield>
          <div id="phoneContainerMobile" class="phone-container-mobile">
            @for (item of phonesControls; track item; let i = $index) {
              <div [id]="'phoneContainerMobile-' + i">
                @if (!item.value.isDeleted) {
                  <div class="phone-inputs-row">
                    <ds-select id="phoneTypeSelectMobile" (selectionChange)="togglePhoneType(item)" [label]="appStrings.contacts_phoneType"
                      [dropOptions]="displayPhoneTypes" label_orientation="vertical-label" class="no-subscript phone-type-field"
                      [control]="item.controls.phoneType">
                    </ds-select>
                    <ds-textfield id="phoneNumberInputMobile" class="fill-width no-subscript phone-number-field" [label]="appStrings.contacts_number"
                      label_orientation="vertical-label" [control]="item.controls.phoneNumber" (onBlur)="togglePhoneType(item)" [maxLength]="maxLengthsInputs.phoneNumber">
                    </ds-textfield>
                    <ds-button id="deleteBtnMobile" class="delete-button-mobile" variant="icon-only" type="tertiary" size="medium"
                      (onClick)="deletePhoneNumber(i)" icon="delete" iconStyle="material-icons-outlined">
                    </ds-button>
                  </div>
                }
              </div>
            }
          </div>
          <ds-button id="addBtnMobile" variant="label-icon" type="tertiary" size="medium"
            [label]="appStrings.contacts_addNumber" (click)="addPhoneNumber()" icon="add" iconPosition="left" iconStyle="material-icons-outlined">
          </ds-button>
          <div class="section-divider">
            <ds-divider></ds-divider>
          </div>
          <typography variant="mat-body-2" weight="bold" class="section-label">{{ appStrings.label_contactAddress }}</typography>
          @if (isLeadPanel) {
            <ds-checkbox id="sameAsLeadCheckboxMobile" [label]="appStrings.contacts_sameAsLead"
              [control]="form.controls.addressToggleCheckbox" (change)="addressToggle()">
            </ds-checkbox>
          }
          <ds-textfield id="primaryAddressInputMobile" class="fill-width no-subscript" [label]="appStrings.contacts_addressLine1"
            label_orientation="vertical-label" [control]="addressFormControls.addressline1" [maxLength]="maxLengthsInputs.addressLine1">
          </ds-textfield>
          <ds-textfield id="secondaryAddressInputMobile" class="fill-width no-subscript" [label]="appStrings.contacts_addressLine2"
            label_orientation="vertical-label" [control]="addressFormControls.addressline2" [maxLength]="maxLengthsInputs.addressLine2">
          </ds-textfield>
          <ds-textfield id="cityInputMobile" class="fill-width no-subscript" [label]="appStrings.contacts_city"
            label_orientation="vertical-label" [control]="addressFormControls.city" [maxLength]="maxLengthsInputs.city">
          </ds-textfield>
          @if (!countryWithCounty && !countryWithHiddenStateProvince) {
            @if (stateList[form.value.address.countryId]) {
              <ds-select id="stateSelectMobile" class="fill-width no-subscript" [label]="appStrings.contacts_state_province"
                [dropOptions]="displayStateList[form.value.address.countryId]" label_orientation="vertical-label"
                [control]="addressFormControls.stateId">
              </ds-select>
            } @else {
              <ds-textfield id="stateInputMobile" class="fill-width no-subscript" [label]="appStrings.contacts_state_province"
                label_orientation="vertical-label" [control]="addressFormControls.province.controls.name">
              </ds-textfield>
            }
          }
          <div class="zip-country-row">
            <ds-textfield id="zipInputMobile" class="fill-width no-subscript zip-field" [label]="appStrings.contacts_zip"
              label_orientation="vertical-label" [control]="addressFormControls.zip" [maxLength]="maxLengthsInputs.zipCode">
            </ds-textfield>
            <ds-select id="countryInputMobile" class="fill-width no-subscript country-field" [label]="appStrings.contacts_country"
              [dropOptions]="displayCountryList" label_orientation="vertical-label" [control]="addressFormControls.countryId"
              (selectionChange)="countryChangedEvent($event.source.value)">
            </ds-select>
          </div>
          @if (countryWithCounty) {
            <ds-select id="regionSelectMobile" class="fill-width no-subscript" [label]="appStrings.contacts_region"
              [dropOptions]="displayRegionList" label_orientation="vertical-label" [control]="addressFormControls.regionId"
              (selectionChange)="regionChangedEvent($event.source.value)">
            </ds-select>
            @if (form.value.address.regionId) {
              <ds-select id="countySelectMobile" class="fill-width no-subscript"
                [label]="appStrings.contacts_county" label_orientation="vertical-label" [dropOptions]="displayCountyList"
                [control]="addressFormControls.countyId">
              </ds-select>
            }
          }
        </mat-expansion-panel>
      }
      <!-- Add/Edit Contact Form Mode -->
      @if (!isLeadPanel) {
        <div class="mobile-contact-form">
          <!-- Title Section -->
          <div class="mobile-contact-header">
            <typography variant="mat-headline-4" weight="bold">{{ title }}</typography>
            @if (accountName || bpNumber) {
              <typography variant="mat-body-2" weight="regular" class="account-info">
                <span class="account-name">{{ accountName }}</span>@if (accountName && bpNumber) {
                <span> | </span>
                }@if (bpNumber) {
                <span><span class="bp-label">BP#:</span> {{ bpNumber }}</span>
              }
            </typography>
          }
        </div>
        <!-- Photo Section -->
        @if (!shouldNotDisplayPhoto) {
          <ds-paper id="photoSectionPaper" elevation="elevation_none" borderRadius="radius_S" outline="outlined"
            insidePaddingTop="top-spacing_L" insidePaddingBottom="bottom-spacing_L"
            insidePaddingLeft="left-spacing_L" insidePaddingRight="right-spacing_L">
            <div class="photo-section">
              <img id="contactPhoto" class="image" alt="contact" [src]="photoUrl" />
              <div id="imgButtons" class="img-buttons">
                <ds-button id="new-photo" class="image-buttons" type="secondary" variant="label-icon" size="medium"
                  [label]="appStrings.button_addPhoto" (onClick)="triggerPreviewPhoto()" iconStyle="material-icons-outlined" icon="upload">
                </ds-button>
                <input #photoFileInput id="photoFileInput" type="file" (change)="previewPhoto($event)"
                  class="file-input" accept="image/png,image/jpg,image/jpeg" />
                <ds-button id="deletePhoto" class="image-buttons delete-photo" type="tertiary" variant="label-icon" size="medium"
                  [isDisabled]="photoUrl === defaultPhotoUrl"
                  [label]="appStrings.button_delete" (onClick)="deletePhoto()" iconStyle="material-icons-outlined" icon="delete">
                </ds-button>
              </div>
            </div>
          </ds-paper>
        }
        <!-- Name Section -->
        <mat-expansion-panel class="mobile-section-panel" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <typography variant="mat-headline-6" weight="bold">{{ appStrings.accounts_labelName }}</typography>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="content">
            <ds-divider></ds-divider>
            <ds-textfield id="firstNameInputMobileContact" class="fill-width no-subscript" [label]="appStrings.contacts_firstName"
              label_orientation="vertical-label" [control]="form.controls.firstName" [maxLength]="maxLengthsInputs.firstName">
            </ds-textfield>
            <ds-textfield id="lastNameInputMobileContact" class="fill-width no-subscript" [label]="appStrings.contacts_lastName"
              label_orientation="vertical-label" [control]="form.controls.lastName" [maxLength]="maxLengthsInputs.lastName">
            </ds-textfield>
            <ds-textfield id="departmentInputMobileContact" class="fill-width no-subscript" [label]="appStrings.contacts_department"
              label_orientation="vertical-label" [control]="form.controls.department" [maxLength]="maxLengthsInputs.department">
            </ds-textfield>
            <ds-textfield id="titleInputMobileContact" class="fill-width no-subscript" [label]="appStrings.contacts_title"
              label_orientation="vertical-label" [control]="form.controls.title" [maxLength]="maxLengthsInputs.title">
            </ds-textfield>
          </div>
        </mat-expansion-panel>
        <!-- Contact Section -->
        <mat-expansion-panel class="mobile-section-panel" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <typography variant="mat-headline-6" weight="bold">{{ appStrings.label_contact }}</typography>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="content">
            <ds-divider></ds-divider>
            <ds-textfield id="emailInputMobileContact" class="fill-width no-subscript" [label]="appStrings.contacts_email"
              label_orientation="vertical-label" [control]="form.controls.email">
            </ds-textfield>
            <div id="phoneContainerMobileContact" class="phone-container-mobile">
              @for (item of phonesControls; track item; let i = $index) {
                <div [id]="'phoneContainerMobileContact-' + i">
                  @if (!item.value.isDeleted) {
                    <div class="phone-inputs-row">
                      <ds-select id="phoneTypeSelectMobileContact" (selectionChange)="togglePhoneType(item)" [label]="appStrings.contacts_phoneType"
                        [dropOptions]="displayPhoneTypes" label_orientation="vertical-label" class="no-subscript phone-type-field"
                        [control]="item.controls.phoneType">
                      </ds-select>
                      <ds-textfield id="phoneNumberInputMobileContact" class="fill-width no-subscript phone-number-field" [label]="appStrings.contacts_number"
                        label_orientation="vertical-label" [control]="item.controls.phoneNumber" (onBlur)="togglePhoneType(item)" [maxLength]="maxLengthsInputs.phoneNumber">
                      </ds-textfield>
                      <ds-button id="deleteBtnMobileContact" class="delete-button-mobile" variant="icon-only" type="tertiary" size="medium"
                        (onClick)="deletePhoneNumber(i)" icon="delete" iconStyle="material-icons-outlined">
                      </ds-button>
                    </div>
                  }
                </div>
              }
            </div>
            <ds-button id="addBtnMobileContact" variant="label-icon" type="secondary" size="medium"
              [label]="appStrings.contacts_addNumber" (click)="addPhoneNumber()" icon="add" iconPosition="left" iconStyle="material-icons-outlined">
            </ds-button>
          </div>
        </mat-expansion-panel>
        <!-- Address Section -->
        <mat-expansion-panel class="mobile-section-panel" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <typography variant="mat-headline-6" weight="bold">{{ appStrings.accounts_labelAddress }}</typography>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="content">
            <ds-divider></ds-divider>
            <ds-textfield id="primaryAddressInputMobileContact" class="fill-width no-subscript" [label]="appStrings.contacts_addressLine1"
              label_orientation="vertical-label" [control]="addressFormControls.addressline1" [maxLength]="maxLengthsInputs.addressLine1">
            </ds-textfield>
            <ds-textfield id="secondaryAddressInputMobileContact" class="fill-width no-subscript" [label]="appStrings.contacts_addressLine2"
              label_orientation="vertical-label" [control]="addressFormControls.addressline2" [maxLength]="maxLengthsInputs.addressLine2">
            </ds-textfield>
            <ds-textfield id="cityInputMobileContact" class="fill-width no-subscript" [label]="appStrings.contacts_city"
              label_orientation="vertical-label" [control]="addressFormControls.city" [maxLength]="maxLengthsInputs.city">
            </ds-textfield>
            @if (!countryWithCounty && !countryWithHiddenStateProvince) {
              @if (stateList[form.value.address.countryId]) {
                <ds-select id="stateSelectMobileContact" class="fill-width no-subscript" [label]="appStrings.contacts_state_province"
                  [dropOptions]="displayStateList[form.value.address.countryId]" label_orientation="vertical-label"
                  [control]="addressFormControls.stateId">
                </ds-select>
              } @else {
                <ds-textfield id="stateInputMobileContact" class="fill-width no-subscript" [label]="appStrings.contacts_state_province"
                  label_orientation="vertical-label" [control]="addressFormControls.province.controls.name">
                </ds-textfield>
              }
            }
            <div class="zip-country-row">
              <ds-textfield id="zipInputMobileContact" class="fill-width no-subscript zip-field" [label]="appStrings.contacts_zip"
                label_orientation="vertical-label" [control]="addressFormControls.zip" [maxLength]="maxLengthsInputs.zipCode">
              </ds-textfield>
              <ds-select id="countryInputMobileContact" class="fill-width no-subscript country-field" [label]="appStrings.contacts_country"
                [dropOptions]="displayCountryList" label_orientation="vertical-label" [control]="addressFormControls.countryId"
                (selectionChange)="countryChangedEvent($event.source.value)">
              </ds-select>
            </div>
            @if (countryWithCounty) {
              <ds-select id="regionSelectMobileContact" class="fill-width no-subscript" [label]="appStrings.contacts_region"
                [dropOptions]="displayRegionList" label_orientation="vertical-label" [control]="addressFormControls.regionId"
                (selectionChange)="regionChangedEvent($event.source.value)">
              </ds-select>
              @if (form.value.address.regionId) {
                <ds-select id="countySelectMobileContact" class="fill-width no-subscript"
                  [label]="appStrings.contacts_county" label_orientation="vertical-label" [dropOptions]="displayCountyList"
                  [control]="addressFormControls.countyId">
                </ds-select>
              }
            }
          </div>
        </mat-expansion-panel>
        <!-- Notes Section -->
        <mat-expansion-panel class="mobile-section-panel" [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <typography variant="mat-headline-6" weight="bold">{{ appStrings.contacts_notes }}</typography>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="content">
            <ds-divider></ds-divider>
            <ds-multiline id="notesInputMobile" class="paragraph-text full-width fill-width no-subscript"
              label_orientation="vertical-label" [control]="form.controls.notes" [maxLength]="maxLengthsInputs.note">
            </ds-multiline>
            <ds-button id="add-note-mobile" type="secondary" variant="label-only" size="medium"
              [label]="appStrings.notesWidget_addNote" [isDisabled]="!form.controls.notes.value"
              (onClick)="addNote()">
            </ds-button>
            @if (notesTableData.length > 0) {
              <div class="notes-list">
                <div class="section-divider">
                  <ds-divider></ds-divider>
                </div>
                @for (note of notesTableData; track note; let index = $index) {
                  <div id="noteDivMobile" class="note-mobile" [id]="'noteMobile'+index">
                    <ds-paper id="notePaperMobile" elevation="elevation_none"
                      borderRadius="radius_S" outline="outlined"
                      insidePaddingTop="top-spacing_M" insidePaddingBottom="bottom-spacing_M"
                      insidePaddingLeft="left-spacing_M" insidePaddingRight="right-spacing_M">
                      <div id="noteContentDivMobile" class="note-content-mobile">
                        <typography id="authorDateMobile" variant="mat-caption-1" weight="bold">{{ note.date | date:dateTimeFormat }}</typography>
                        <typography id="noteTextMobile" variant="mat-body-2" weight="regular">{{note.detail}}</typography>
                      </div>
                      <div id="noteActionsDivMobile" class="note-actions-mobile">
                        @if (!isView) {
                          <ds-button id="deleteNoteButtonMobile" size="medium" type="tertiary" variant="icon-only" icon="delete"
                            iconStyle="material-icons-outlined" (onClick)="deleteNote(index)">
                          </ds-button>
                        }
                      </div>
                    </ds-paper>
                  </div>
                }
              </div>
            }
          </div>
        </mat-expansion-panel>
      </div>
    }
    <!-- Sticky Footer for Mobile Add/Edit Contact -->
    <div class="mobile-sticky-footer">
      <ds-button id="cancelButtonMobile" size="medium" type="secondary"
        variant="label-only" [label]="appStrings.button_cancel" (onClick)="confirmCancel()">
      </ds-button>
      @if (isEditMode) {
        <div>
          <ds-button id="saveButtonEditMobile" size="medium" type="primary"
            variant="label-only" [isDisabled]="!isOnline || isLoading" [label]="appStrings.button_save"
            (onClick)="editSaveChanges()">
          </ds-button>
        </div>
      } @else {
        @if (!shouldNotDisplayPhoto) {
          <ds-button id="saveNewButtonMobile" size="medium"
            type="secondary" variant="label-only" [isDisabled]="isLoading"
            [label]="appStrings.button_saveAndNew" (onClick)="saveChangesAndNew()">
          </ds-button>
        }
        <ds-button id="saveButtonMobile" size="medium" type="primary"
          variant="label-only" [isDisabled]="isLoading" [label]="appStrings.button_save"
          (onClick)="saveChanges()">
        </ds-button>
      }
    </div>
  </div>
  @if (!isLeadPanel) {
    <div id="bigContainer" class="big-container">
      <div id="deleteButtonContainer">
        @if (isOnline && isEditMode && canEdit) {
          <ds-button id="deleteButton" class="delete-button"
            type="secondary" variant="label-only" size="medium" [label]="appStrings.contacts_deleteContactTitle"
            (onClick)="deleteContact()">
          </ds-button>
        }
      </div>
    </div>
  }
</form>
}

<ds-dialog
  id="confirmDialog"
  [title]="dialogTitle"
  [description]="dialogText"
  [actionButtons]="dialogButtons"
  [open]="dialogOpen$">
</ds-dialog>
